export const Enviroment = {
    /**
     * Define a quantidade de linha a ser carregada por padrão nas listagens
     */
    LIMITE_DE_LINHAS: 20, //10,

    /**
     * Texto placeholder do campo de pesquisa
     */
    INPUT_DE_BUSCA: "Pesquisar...",

    /**
     * Texto quando não tiver dados para serem exibidos em uma listagem
     */
    LISTAGEM_VAZIA: "Nenhum registro encontrado.",

    /**
     * Caminho da API da aplicação 
     */

    
    URL_BASE: "https://bskt.fantasygm.com.br:82/api", // produção 
    //URL_BASE: "https://bskt.fantasygm.com.br/api", // ambiente não definido
    //URL_BASE: "http://192.91.254.122:5081/api", // homologação         
    //URL_BASE: "https://localhost:62079/api", // local
    //URL_BASE: "https://localhost:44444/api", // local Gabriel

    //******TROCAR para TRUE quando for publicar em produção ***************
    //AMBIENTE_PRODUCAO: false,
    AMBIENTE_PRODUCAO: true,

    CHAVE_HOMOLOGACAO: "7709A7FF-F313-4D90-9132-82C5D881D3F6",
    CHAVE_HOMOLOGACAO_CREATE: "E8513EC1-1E9D-4A5E-B21F-CBECE677668D",
    MANUNTENCAO: false,
    ID_USUARIO_ACESSO: 2
};